export class UnregisteredUserDocument {
  documentVersionCode: string;
  documentName: string;
  documentDate: string;
  documentNumber: string;
  isProcessingAllowed: boolean;
  isFileOperationsAllowed: boolean;
  isAnnulled: boolean;

  isProcessed: boolean;
  files: Array<UnregisteredUserDocumentFileModel>;
  actions: Array<UnregisteredUserDocumentActionModel>;
  signatures: Array<UnregisteredUserDocumentSignatureModel>;

  constructor(dto?: UnregisteredUserDocument) {
    this.documentVersionCode = dto?.documentVersionCode || '';
    this.documentName = dto?.documentName || '';
    this.documentDate = dto?.documentDate || '';
    this.documentNumber = dto?.documentNumber || '';
    this.isProcessingAllowed = dto?.isProcessingAllowed || false;
    this.isFileOperationsAllowed = dto?.isFileOperationsAllowed || false;
    this.isAnnulled = dto?.isAnnulled || false;
    this.isProcessed = dto?.isProcessed || false;
    this.files = (dto?.files || []).map(f => new UnregisteredUserDocumentFileModel(f));
    this.actions = (dto?.actions || []).map(a => new UnregisteredUserDocumentActionModel(a));
    this.signatures = (dto?.signatures || []).map(s => new UnregisteredUserDocumentSignatureModel(s));
  }
}

export class UnregisteredUserDocumentFileModel {
  documentFileCode: string;
  documentVersionsFileCode: string;
  fileName: string;
  fileSize: number;
  dateAdd: string;
  isPicture: boolean;
  isPdf: boolean;
  documentVersion: number;
  isMainFile: boolean;
  isCoverLetter: boolean;
  isMainDocumentFile: boolean;
  docSignCount: number;
  previousVersions: Array<UnregisteredUserDocumentFileModel> = [];

  constructor(dto?: UnregisteredUserDocumentFileModel) {
    this.documentFileCode = dto?.documentFileCode || '';
    this.documentVersionsFileCode = dto?.documentVersionsFileCode || '';
    this.fileName = dto?.fileName || '';
    this.fileSize = dto?.fileSize || 0;
    this.dateAdd = dto?.dateAdd || '';
    this.isPicture = dto?.isPicture || false;
    this.isPdf = dto?.isPdf || false;
    this.documentVersion = dto?.documentVersion || 0;
    this.isMainFile = dto?.isMainFile || false;
    this.isCoverLetter = dto?.isCoverLetter || false;
    this.isMainDocumentFile = dto?.isMainDocumentFile || false;
    this.docSignCount = dto?.docSignCount || 0;
  }
}

export class UnregisteredUserDocumentActionModel {
  actionType: string;
  documentActionId: number;
  documentActionUserId: number;
  documentActionUserName: string;
  isActual: boolean;
  stageNumber: number;
  isSealRequired: boolean;
  actionMaxDate: string;
  senderFullName: string;
  senderOrganisation: string;
  senderComment: string;
  actionStatus: number;
  sendDate: string;
  decisionDate: string;
  decisionComment: string;
  isProcessingAllowed: boolean;
  isActionOverdue: boolean;

  constructor(dto?: UnregisteredUserDocumentActionModel) {
    this.actionType = dto?.actionType || '';
    this.documentActionId = dto?.documentActionId || 0;
    this.documentActionUserId = dto?.documentActionUserId || 0;
    this.documentActionUserName = dto?.documentActionUserName || '';
    this.isActual = dto?.isActual || false;
    this.stageNumber = dto?.stageNumber || 0;
    this.isSealRequired = dto?.isSealRequired || false;
    this.actionMaxDate = dto?.actionMaxDate || '';
    this.senderFullName = dto?.senderFullName || '';
    this.senderOrganisation = dto?.senderOrganisation || '';
    this.senderComment = dto?.senderComment || '';
    this.actionStatus = dto?.actionStatus || 0;
    this.sendDate = dto?.sendDate || '';
    this.decisionDate = dto?.decisionDate || '';
    this.decisionComment = dto?.decisionComment || '';
    this.isProcessingAllowed = dto?.isProcessingAllowed || false;
    this.isActionOverdue = dto?.isActionOverdue || false;
  }
}

export class UnregisteredUserDocumentCurrentProcessing {
  acquainting?: UnregisteredUserDocumentActionModel;
  isAcquaintingAllowed: boolean = false;
  agreeing?: UnregisteredUserDocumentActionModel;
  isAgreeingAllowed: boolean = false;
  signing?: UnregisteredUserDocumentActionModel;
  isSigningAllowed: boolean = false;
}

export class UnregisteredUserDocumentSignatureModel {
  documentVersionsFileCode: string;
  documentVerFilesSignId: number;
  documentSignUserId: number;
  documentUserSignsId: number;
  documentAcquaintUserId: number;
  documentAcquaintUserSignsId: number;
  documentAgreeUserId: number;
  documentAgreeUserSignsId: number;
  dateSign: string;
  signTimeStamp: string;
  fileName: string;
  fio: string;
  type: number;
  documentVersion: number;
  signSubFullName: number;
  signSubOrg: number;
  signSubIsOrganization: boolean;
  isStump: number;
  signSubIssuer: string;
  isMainFile: boolean;
  signFileTypeId: number;
  documentVerFileSignId: number;
  nestedLevel: number;
  nestedIndex: number;

  constructor(dto?: any) {
    this.documentVersionsFileCode = dto?.documentVersionsFilecode || '';
    this.documentVerFilesSignId = dto?.documentVerFilesSignId || 0;
    this.documentSignUserId = dto?.documentSignUserId || 0;
    this.documentUserSignsId = dto?.documentUserSignsId || 0;
    this.documentAcquaintUserId = dto?.documentAcquaintUserId || 0;
    this.documentAcquaintUserSignsId = dto?.documentAcquaintUserSignsId || 0;
    this.documentAgreeUserId = dto?.documentAgreeUserId || 0;
    this.documentAgreeUserSignsId = dto?.documentAgreeUserSignsId || 0;
    this.dateSign = dto?.dateSign || '';
    this.signTimeStamp = dto?.signTimeStamp || '';
    this.fileName = dto?.fileName || '';
    this.fio = dto?.fio || '';
    this.type = dto?.type || 0;
    this.documentVersion = dto?.documentVersion || 0;
    this.signSubFullName = dto?.signSubFullname || '';
    this.signSubOrg = dto?.signSubOrg || '';
    this.signSubIsOrganization = dto?.signSubIsOrganization || false;
    this.isStump = dto?.isStump || 0;
    this.signSubIssuer = dto?.signSubIssuer || '';
    this.isMainFile = dto?.isMainFile || false;
    this.signFileTypeId = dto?.signFileTypeId || 0;
    this.documentVerFileSignId = dto?.documentVerFileSignId || 0;
    this.nestedLevel = dto?.nestedLevel || 0;
    this.nestedIndex = dto?.nestedIndex || 0;
  }
}
